import { render, staticRenderFns } from "./ClubSignUp.vue?vue&type=template&id=296a3446&scoped=true&"
import script from "./ClubSignUp.vue?vue&type=script&lang=ts&"
export * from "./ClubSignUp.vue?vue&type=script&lang=ts&"
import style0 from "./ClubSignUp.vue?vue&type=style&index=0&id=296a3446&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296a3446",
  null
  
)

export default component.exports